module.exports = __webpack_public_path__ + "images/private-investor-c93a25.png";